import React, { useState, useEffect } from "react";
import { useDebounceCallback } from "../../../containers/AdFormPage/LocationSelector/hooks/useDebounceCallback";

export const MileageWarning = ({ value, validationErrorIsShown }) => {
  const [visible, setVisible] = useState(false);

  const showWarning = useDebounceCallback(() => setVisible(true), 1000);

  useEffect(() => {
    setVisible(false);
    showWarning();
  }, [value]);

  const shouldRenderMileageWarning = !validationErrorIsShown && (value && value.length < 5) && visible

  return shouldRenderMileageWarning ? (
    <div style={{
      marginTop: 3,
      marginBottom: -10,
      color: "rgb(248, 150, 30)",
      lineHeight: 1.5,
    }}>
      Provjerite jeste li ispravno upisali kilometražu
    </div>
  ) : null;
}


// WEBPACK FOOTER //
// ./src/components/FormControls/InputText/MileageWarning.tsx